module.exports = __webpack_public_path__ + "img/intent_3.e9546d2d.png";